import { render, staticRenderFns } from "./NCStatistics.vue?vue&type=template&id=1ebe2f9c&scoped=true"
import script from "./NCStatistics.vue?vue&type=script&lang=js"
export * from "./NCStatistics.vue?vue&type=script&lang=js"
import style0 from "./NCStatistics.vue?vue&type=style&index=0&id=1ebe2f9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebe2f9c",
  null
  
)

export default component.exports